import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { ImportLogsService } from '@services/import-logs/import-logs.service';
import { ImportService } from '@services/imports/import.service';
import { PipeImportService } from '@services/pipe-imports/pipe-import.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DataTableEvent } from '../../../components/data-table/data-table.component';

@Component({
    selector: 'app-pipe-import-logs',
    templateUrl: './pipe-import-logs.component.html',
    styleUrls: ['./pipe-import-logs.component.scss'],
    providers: [ImportLogsService, ImportService, PipeImportService],
    standalone: false
})
export class PipeImportLogsComponent implements OnInit {

  public title = 'All Import Logs';

  public subtitle: string;

  public pageActions: PageAction[];

  public importId: string = null;

  public pipeImport;

  public columns = [
    { prop: 'title', name: 'Title' },
    {
      prop: 'created', valueTransformer: function(date) {
        if (!date) { return null }
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'lastCheck', valueTransformer: function(date) {
        if (!date) { return null }
        return moment(date).format('DD-MM-YYYY  HH:mm');
      }
    },
    {
      prop: 'importWasSuccess', name: 'Failed', valueTransformer: function(data) {
        return data ? '' : 'Error';
      }
    }
  ];

  public params: any;

  constructor(
    public importLogsService: ImportLogsService,
    public importService: ImportService,
    public pipeImportService: PipeImportService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {

    this.importId = this.route.snapshot.params['id'];
    this.params = { importId: this.importId, $sort: { created: -1 } };
    this.pipeImportService.get(this.importId).then(res => {
      this.pipeImport = res;
      this.title = this.pipeImport.title;
      this.createPageActions();
    });

  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['pipe-imports', this.importId, 'logs', event.row._id]);
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({
        icon: 'subdirectory_arrow_left',
        title: 'Go to Importer',
        callback: () => {
          this.router.navigate(['pipe-imports/', this.importId]);
        }
      }),
    ];
  }
}

